import React from "react";
import {getFooterLinks} from './getFooterLinks';
import './resources/scss/FooterWeb.scss';

export const FooterWeb= ()=>{
    const extractDomain = () => {
        let domain = "";
        const url = window.location.origin;
        if (url.includes("localhost" || "test")) {
          domain = "https://recruiter.foundit.in";
        } else {
          domain = window.location.origin;
        }
        return domain;
      };
      
    const baseUrl = extractDomain();
    const currentYear = new Date().getFullYear();
    const footerLinks = getFooterLinks(baseUrl);
    return (
      <footer className="recruiter_footer">
        <div className="recruiter_footer_container">
          <div className="recruiter_footer_label">© {currentYear} foundit - All Rights Reserved</div>
          <ul className="recruiter_footer_right_section">
          {
              (footerLinks || []).map(item => (
              <li className="recruiter_footer_links"><a href={item?.link} className="recruiter_footer_link">{item?.title}</a></li>
              ))
          }
          </ul>
        </div>
          
    </footer>
    )
} 